import classNames from "classnames";
import { memo, useState } from "react";
import { Flex } from "./flex";
import * as styles from "./product-list-row.module.css";
import { Text } from "./text";
import { Tooltip } from "./tooltip/tooltip";

export const ProductListItem = memo(function ProductListItem({
  title,
  imageUrl,
  variantTitle,
  sku,
  serialNumbers,
  disableTooltip = false,
  imageTooltipPlacement = "left",
}: {
  title: string;
  imageUrl: string | null | undefined;
  variantTitle: string | null | undefined;
  sku: string | null | undefined;
  serialNumbers?: readonly string[] | null;
  disableTooltip?: boolean;
  imageTooltipPlacement?: "left" | "right" | "top" | "bottom";
}) {
  const [productTitleElementRef, setProductTitleElementRef] =
    useState<HTMLParagraphElement | null>(null);

  const titleIsOverflowing = productTitleElementRef
    ? productTitleElementRef.scrollWidth > productTitleElementRef.clientWidth
    : false;

  return (
    <Tooltip title={!titleIsOverflowing || disableTooltip ? "" : title}>
      <Flex gap="md">
        {imageUrl ? (
          <Tooltip
            arrow
            enterDelay={700}
            enterNextDelay={500}
            placement={imageTooltipPlacement}
            title={
              <img
                alt={title}
                className={classNames(styles.productImage, styles.tooltip)}
                src={imageUrl}
              />
            }
          >
            <img
              className={styles.productImage}
              data-web="ProductListItem"
              src={imageUrl}
            />
          </Tooltip>
        ) : null}
        <Flex justify="space-between" w="full">
          <Flex flexDirection="column" gap="xs" justify="center">
            <Text
              className={styles.wrapAndEllipsesOverflow}
              fontSize="xs"
              fontWeight="medium"
              ref={setProductTitleElementRef}
            >
              {title}
            </Text>
            {variantTitle && variantTitle !== "Default Title" && (
              <Text
                className={styles.wrapAndEllipsesOverflow}
                fontSize="xxs"
                textColor="tertiary"
              >
                {variantTitle.replace(" / ", ", ")}
              </Text>
            )}
            {sku && (
              <Text
                className={styles.wrapAndEllipsesOverflow}
                fontSize="xxs"
                textColor="tertiary"
              >
                {sku}
              </Text>
            )}
            {serialNumbers?.map((serialNumber) => (
              <Text
                className={styles.wrapAndEllipsesOverflow}
                fontSize="xxs"
                key={serialNumber}
                textColor="tertiary"
              >
                {serialNumber}
              </Text>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Tooltip>
  );
});
